module.exports = __webpack_public_path__ + "static/media/zach1.e82084c9.png";